import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { showSuccess, showError } from "../../utils/alerts";
import { loginUser, clearError } from '../../store/slices/authSlice';
import logo from "../../../src/assets/images/logo-samplee.png";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading, error, isAuthenticated } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      showSuccess("Login Successful", "Welcome back!");
      navigate("/dashboard");
    }

    if (error) {
      showError("Login Failed", error);
    }
  }, [isAuthenticated, error, navigate]);

  useEffect(() => {
    // Clear any existing errors when component mounts
    dispatch(clearError());
  }, [dispatch]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(loginUser(formData));
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="authentication-wrapper authentication-cover">
      {/* Logo */}
      {/* /Logo */}

      <div className="authentication-inner row m-0">
        {/* Left Section */}
        <div className="d-none d-lg-flex col-lg-7 col-xl-8 align-items-center justify-content-center p-12 pb-2" style={{ backgroundColor: "#527ca2" }}>
          <img
            src="/assets/img/illustrations/auth-reset-password-illustration-light.png"
            className="auth-cover-illustration w-100"
            alt="auth-illustration"
            data-app-light-img="illustrations/auth-reset-password-illustration-light.png"
            data-app-dark-img="illustrations/auth-login-illustration-dark.png"
          />
          <img
            src="/assets/img/illustrations/auth-cover-login-mask-light.png"
            className="authentication-image"
            alt="mask"
            data-app-light-img="illustrations/auth-cover-login-mask-light.png"
            data-app-dark-img="illustrations/auth-cover-login-mask-dark.png"
          />
        </div>
        {/* /Left Section */}

        {/* Login Form */}
        <div className="d-flex col-12 col-lg-5 col-xl-4 align-items-center authentication-bg position-relative py-sm-12 px-12 py-6">
          <div className="w-px-400 mx-auto pt-5 pt-lg-0">
            <div className="text-center mb-4">
              <img
                src={logo}
                alt="Recovery House Logo"
                style={{ width: "200px", height: "auto" }}
                className="mb-3"
              />
              <h4 className="my-1">Welcome to Recovery House</h4>
              <p className="mb-5">Please sign-in to your account and start the adventure</p>
            </div>

            {/* {error && <div className="alert alert-danger">{error}</div>} */}

            <form id="formAuthentication" className="mb-5" onSubmit={handleSubmit}>
              <div className="form-floating form-floating-outline mb-5">
                <input
                  type="text"
                  className="form-control"
                  id="email"
                  name="email"
                  placeholder="Enter your email or username"
                  value={formData.email}
                  onChange={handleChange}
                  disabled={isLoading}
                  autoFocus
                />
                <label htmlFor="email">Email or Username</label>
              </div>

              <div className="mb-5">
                <div className="form-password-toggle">
                  <div className="input-group input-group-merge">
                    <div className="form-floating form-floating-outline">
                      <input
                        type={showPassword ? "text" : "password"}
                        id="password"
                        className="form-control"
                        name="password"
                        placeholder="••••••••••••"
                        value={formData.password}
                        onChange={handleChange}
                        disabled={isLoading}
                        aria-describedby="password"
                      />
                      <label htmlFor="password">Password</label>
                    </div>
                    <span
                      className="input-group-text cursor-pointer"
                      onClick={togglePasswordVisibility}
                      style={{ cursor: 'pointer' }}
                    >
                      <i className={`ri-eye${showPassword ? '-line' : '-off-line'}`}></i>
                    </span>
                  </div>
                </div>
              </div>

              <div className="mb-5 d-flex justify-content-between mt-5">
                <div className="form-check mt-2">
                  <input className="form-check-input" type="checkbox" id="remember-me" />
                  <label className="form-check-label" htmlFor="remember-me">
                    Remember Me
                  </label>
                </div>
                {/* <Link to="/forgot-password" className="float-end mb-1 mt-2">
                  <span>Forgot Password?</span>
                </Link> */}
              </div>

              <button
                type="submit"
                className="btn btn-primary d-grid w-100"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  </>
                ) : (
                  'Sign in'
                )}
              </button>
            </form>

            {/* <p className="text-center">
              <span>New on our platform?</span>
              <Link to="/register">
                <span> Create an account</span>
              </Link>
            </p> */}

            {/* <div className="divider my-5">
              <div className="divider-text">or</div>
            </div> */}

            {/* <div className="d-flex justify-content-center gap-2">
              <a href="javascript:;" className="btn btn-icon rounded-circle btn-text-facebook">
                <i className="tf-icons ri-facebook-fill"></i>
              </a>

              <a href="javascript:;" className="btn btn-icon rounded-circle btn-text-twitter">
                <i className="tf-icons ri-twitter-fill"></i>
              </a>

              <a href="javascript:;" className="btn btn-icon rounded-circle btn-text-github">
                <i className="tf-icons ri-github-fill"></i>
              </a>

              <a href="javascript:;" className="btn btn-icon rounded-circle btn-text-google-plus">
                <i className="tf-icons ri-google-fill"></i>
              </a>
            </div> */}
          </div>
        </div>
        {/* /Login Form */}
      </div>
    </div>
  );
};

export default Login;